import { useFormikContext } from "formik";
import { InputField, VerticalForm, } from "melco-shared-logic";
import { Button, Space, SaveIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";


const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;


export const DisplayNewForwardForm: React.FC = () => {
    const { t } = useTranslation();
    const { isSubmitting, submitForm } = useFormikContext();

    return (
        <>
            <div>

                <Right direction="vertical" size="small">
                    <Button
                        icon={<SaveIcon />}
                        type="primary"
                        // disabled={isSubmitting}
                        loading={isSubmitting}
                        onClick={() => {
                            submitForm();
                        }}
                        style={{ marginBottom: "15px" }}
                    >
                        {t("url_forward.actions.add_new.title")}
                    </Button>
                </Right>


                <VerticalForm>

                    <InputField
                        name="key"
                        label={t("url_forward.actions.add_new.form.input.key")}
                        placeholder={t("url_forward.actions.add_new.form.input.key_placeholder")}
                    />
                    <InputField
                        name="target"
                        label={t("url_forward.actions.add_new.form.input.target")}
                        placeholder={t("url_forward.actions.add_new.form.input.target_placeholder")}
                    />

                </VerticalForm>
            </div>
        </>

    );
};
